<div class="l-core-contents__tabpanel is-current" id="panel-2" role="tabpanel" aria-labelledby="tab2" tabindex="-1">
  <div class="l-core-contents__inner">
    <div class="l-core-contents__main">
      <!-- 1.1 代表者連絡先情報	 -->
      <asw-representive-contacts></asw-representive-contacts>
      <!-- 1.3 搭乗者情報	 -->
      <asw-passenger-information></asw-passenger-information>
    </div>
    <div class="l-core-contents__sub">
      <div class="p-sub-column-layout02">
        <div class="p-sub-column-layout02__body">
          <asw-my-booking-slidebar-menu
            [isItineraryMenuByScreenShow]="isDisplayItineraryOperationMenu"
            [isBizMenuByScreenShow]="isBizMenu"
            [isRecommentByScreenShow]="isDisplayRecommend"
          ></asw-my-booking-slidebar-menu>
        </div>
      </div>
    </div>
  </div>
</div>
